import { apiGet } from '../generic/Api_Functions'

const getResourceTypes = () => {
  return [{ name: 'Fixture', label: 'Fixture' }, { name: 'Tool', label: 'Tool' }, { name: 'RawMaterial', label: 'RawMaterial' }, { name: 'Part', label: 'Part' }].sort((i1, i2) => i1.label.localeCompare(i2.label))
}

const getToolResourceType = () => {
  return [{ name: 'Tool', label: 'Tool' }]
}

const getResourcesByType = async (typeName, getByPlanification, fixtureReferences) => {
  if (!typeName) {
    return []
  }
  if (typeName === 'Part') {
    const response = await apiGet('partReferencesDto/' + getByPlanification + '?compatibleFixtureReferenceCodes=' + fixtureReferences)
    return response
  }
  if (typeName === 'Fixture') {
    return await apiGet('fixtureReferencesDto?compatibleFixtureReferenceCodes=' + fixtureReferences)
  }
  if (typeName === 'Tool') {
    return await apiGet('toolReferencesDto?compatibleFixtureReferenceCodes=' + fixtureReferences)
  }
  if (typeName === 'RawMaterial') {
    return await apiGet('rawMaterialsReference?compatibleFixtureReferenceCodes=' + fixtureReferences)
  }
}

const getFabricationOrders = async () => {
  return await apiGet('getAllUnfinishedAndActiveFabricationOrders')
}

export { getResourceTypes, getToolResourceType, getResourcesByType, getFabricationOrders }
